
<template lang="pug">
  .eui-error(v-if="error")
      span Error: {{ error }}
</template>


<script>
export default {
  name: 'euiError',
  props: {
    error: {
      type: String
    }
  }
};

</script>

<style lang="scss">

.eui-error {
  display: block;
  color: #dd0000;
  padding: var(--theme-spacing) 0;
  font-size: 12px;
}


</style>
